import { useState, useCallback, useEffect } from "react";
import { useApi } from "providers/ApiProvider";
import { BoilerplateMemoCategory } from "~/core/resources/filesApi";
import { styled } from "@mui/material";

export const Box = styled("div")`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  width: 100%;
  p {
    flex: 0 0 auto;
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
  button {
    cursor: pointer;
    height: 24px;
    max-width: 96px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 3px 10px 3px;
    font-size: 12px;
    margin-left: 8px;
    border: solid 1px #dee2ec;
    background-color: #fff;
    color: #484760;
  }
`;

const MemoBoilerplate = ({
  category,
  memo,
  setMemo,
}: {
  category: BoilerplateMemoCategory;
  memo: string;
  setMemo: (memo: string) => void;
}) => {
  const { filesApi } = useApi();
  const [memoBoilerplateList, setMemoBoilerplateList] = useState<any[]>([]);

  const loadMemoBoilerPlate = useCallback(async () => {
    const res = await filesApi.getMemoBoilerPlates(category);
    const payload = await res.data;
    setMemoBoilerplateList(payload.data);
  }, []);

  useEffect(() => {
    loadMemoBoilerPlate();
  }, [category]);

  if (memoBoilerplateList?.length === 0) {
    return <></>;
  }

  return (
    <Box>
      <p>자주 쓰는 상용구</p>
      {memoBoilerplateList
        .slice(0, 5)
        .map((v: { title: string; contents: string }, i: number) => (
          <button
            key={i}
            onClick={() =>
              setMemo((memo === "<p><br></p>" ? "" : memo) + v.contents)
            }
          >
            {v.title}
          </button>
        ))}
    </Box>
  );
};

export default MemoBoilerplate;
